import { autoserializeAs } from "cerialize";
import { OrganizationRider } from "./organization-rider";
import { OrganizationRiderServiceLevel } from "./organization-rider-service-level";

export class OrganizationRiderCreationRequest {
  @autoserializeAs(OrganizationRider)
  organizationRider: OrganizationRider;

  @autoserializeAs(OrganizationRiderServiceLevel)
  organizationRiderServiceLevels: Array<OrganizationRiderServiceLevel>;
}
